import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9885 5.06874C14.025 6.69398 15.3523 8 16.9846 8c1.6553 0 2.997-1.343 2.997-3s-1.3417-3-2.997-3c-.9573 0-1.8096.44917-2.3583 1.14848C14.1023 3.05127 13.5622 3 13.0095 3 9.87173 3 7.11256 4.612 5.50421 7.051c.72525.074 1.40056.297 1.99995.648C8.78485 6.06 10.7738 5 13.0095 5c.3323 0 .6591.02345.979.06874zM6.51347 14.5882C7.39931 14.067 7.99386 13.1031 7.99386 12c0-1.657-1.34163-3-2.99693-3C3.34162 9 2 10.343 2 12c0 1.4939 1.09052 2.7326 2.51826 2.962 1.1598 3.326 4.21874 5.7585 7.87634 6.0072-.2587-.605-.4045-1.27-.4045-1.969 0-.028.008-.054.008-.082-2.49839-.3648-4.57397-2.0528-5.48463-4.33zm11.93983 1.796c-.434-.2446-.935-.3842-1.4687-.3842-1.6553 0-2.9969 1.343-2.9969 3s1.3416 3 2.9969 3c1.6553 0 2.997-1.343 2.997-3 0-.3835-.0719-.7502-.2029-1.0873C21.1612 16.3329 22 14.2659 22 11.9998c0-1.468-.3586-2.85-.981-4.074-.4126.569-.943 1.037-1.5534 1.39.3446.827.5364 1.733.5364 2.684 0 1.6593-.5807 3.1843-1.5487 4.3844z",
    fill: "currentColor"
  }));
});